function SelfServicePage() {
  return <p>This is Self service Page</p>;
}
export { SelfServicePage };
